export interface ConfigValidationResult {
  isValid: boolean;
  missingFields: string[];
}

export const validateEnvironmentVariables = (): ConfigValidationResult => {
  const requiredVars = [
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_AUTH_DOMAIN',
    'VITE_FIREBASE_PROJECT_ID',
    'VITE_FIREBASE_STORAGE_BUCKET',
    'VITE_FIREBASE_MESSAGING_SENDER_ID',
    'VITE_FIREBASE_APP_ID',
    'VITE_FACEBOOK_APP_ID'
  ];

  const missingFields = requiredVars.filter(
    varName => !import.meta.env[varName]
  );

  return {
    isValid: missingFields.length === 0,
    missingFields
  };
};

export const validateFirebaseConfig = (config: Record<string, any>): ConfigValidationResult => {
  const requiredFields = [
    'apiKey',
    'authDomain',
    'projectId',
    'storageBucket',
    'messagingSenderId',
    'appId'
  ];

  const missingFields = requiredFields.filter(field => !config[field]);

  return {
    isValid: missingFields.length === 0,
    missingFields
  };
};